module.exports = __webpack_public_path__ + "img/det_coupon_top_bg.aae49d49.png";